/**
 * components/filters/tablePagination.js — ХҮСНЭГТИЙН ХУУДАСЛАЛТЫН СТАНДАРТ.
 *
 * АСУУДАЛ: жагсаалт бүр өөр өөр хуудасны хэмжээтэй (20 · 30 · 50 · 100)
 * бөгөөд зарим нь «хэдэн бичлэг харуулах» сонголтгүй байв. Хэрэглэгч нэг
 * хуудсанд 20, нөгөөд 50 мөр хардаг тул харьцуулах, хэвших боломжгүй.
 *
 * СТАНДАРТ:
 *   анхдагч        25 мөр
 *   сонголт        25 · 50 · 100 · 200
 *   нийт тоо       «нийт N бичлэг» гэж ҮРГЭЛЖ харагдана
 *   хэмжээ         small (hseStandard.css-тэй нийцнэ)
 *
 * Хэрэглэх:
 *   <Table pagination={tablePagination()} ... />
 *   <Table pagination={tablePagination({ pageSize: 50 })} ... />   // онцгой
 *   <Table pagination={tablePagination({ current: page, total, onChange })} />
 */
export const PAGE_SIZE_OPTIONS = ["25", "50", "100", "200"];
export const DEFAULT_PAGE_SIZE = 25;

export function tablePagination(extra = {}) {
  return {
    size: "small",
    defaultPageSize: DEFAULT_PAGE_SIZE,
    pageSize: undefined, // дуудагч өөрөө удирдвал дарж бичнэ
    showSizeChanger: true,
    pageSizeOptions: PAGE_SIZE_OPTIONS,
    showTotal: (total, range) =>
      total ? `${range[0]}-${range[1]} / нийт ${total} бичлэг` : "",
    ...extra,
  };
}

export default tablePagination;
